import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  NavbarBrand,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom"; // React Router v6

const Login = () => {
  const [email, setEmail] = useState(""); // State for email
  const [password, setPassword] = useState(""); // State for password
  const [loading, setLoading] = useState(false); // State for loading
  const [error, setError] = useState(""); // State for error messages
  const navigate = useNavigate(); // Hook to navigate between routes

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "", // leave blank for login if not required
          },
          // withCredentials: true, // uncomment if backend uses cookies
        },
      );

      console.log(response);

      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("token", response.data.user.token);
      localStorage.setItem("userData", JSON.stringify(response.data.user));

      navigate("/admin/index");
    } catch (error) {
      console.error("Login error:", error);

      if (axios.isAxiosError(error)) {
        setError(error.response?.data?.message || "Invalid email or password");
      } else {
        setError("Network or unexpected error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Col lg="8" md="9">
        <Card
          style={{ background: "rgba(1,1,1,0.8)" }}
          className="shadow border-0"
        >
          <CardBody className="px-lg-7 py-lg-6">
            <NavbarBrand to="/">
              <span
                style={{
                  color: "white",
                  fontSize: "25px",
                  fontWeight: "bolder",
                  textAlign: "start",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
                }}
              >
                Sign with <br />{" "}
                <span style={{ color: "#FFB000" }}>Trypto Admin Panel</span>
              </span>
            </NavbarBrand>

            <div className="text-center text-muted mb-4"></div>

            {/* Error Message Display */}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <Form onSubmit={handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} // Update email state
                    autoComplete="new-email"
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} // Update password state
                  />
                </InputGroup>
              </FormGroup>

              <div className="text-center">
                <Button
                  className="mb-3 px-lg-9"
                  style={{
                    background: "#FFB000",
                    color: "black",
                    border: "none",
                    fontSize: "20px",
                    fontWeight: "bolder",
                    marginTop: "30px",
                  }}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Signing in...
                    </>
                  ) : (
                    "Sign in"
                  )}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            >
              {/* <small>Forgot password?</small> */}
            </a>
          </Col>
          <Col className="text-right" xs="6">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            >
              {/* <small>Create new account</small> */}
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
